<template>
  <div class="perfectingInformation">
    <div class="detailedInformation">
      <el-card-title :title="title" />
      <el-form
        ref="ruleForm.coopUnitBO"
        :model="ruleForm.coopUnitBO"
        :rules="rules"
        label-width="135px"
        class="demo-ruleForm"
      >
        <el-form-item label="合作单位：" prop="companyName">
          <el-input
            v-model="ruleForm.coopUnitBO.companyName"
            class="input-long"
            placeholder="请输入合作单位全称"
            @blur="getIdByName"
            maxlength="200"
          />
          <span class="nameTip"
            >合作单位将作为{{ supplierData.supplierName }}入网的审核单位</span
          >
        </el-form-item>

        <el-form-item label="推荐人姓名：">
          <el-input
            v-model="ruleForm.coopUnitBO.recomName"
            @input="checkName"
            maxlength="50"
            class="input-long"
            placeholder="请输入推荐人姓名"
          />
        </el-form-item>

        <el-form-item label="推荐人电话：">
          <el-input
            v-model="ruleForm.coopUnitBO.recomMobile"
            @input="checkMobile"
            maxlength="30"
            placeholder="请输入推荐人电话"
            class="input-short"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form
        ref="ruleForm.coopEnterpriseBO"
        :model="ruleForm.coopEnterpriseBO"
        :rules="rules"
        label-width="135px"
        class="demo-ruleForm"
      >
        <el-card-title :title="title1" />
        <el-multi-level-selector
          :supplier-data="supplierData"
          :radio-value="radioValue"
          @change="selSupplier"
          style="margin: 20px 0 0 90px"
          required
        ></el-multi-level-selector>

        <el-card-title title="产品说明" />
        <el-form-item
          label="产能："
          prop="capacity"
          ref="capacity"
          id="capacity"
        >
          <el-input
            v-model="ruleForm.coopEnterpriseBO.capacity"
            maxlength="50"
            class="input-long"
            placeholder="请输入产能"
          />
        </el-form-item>
        <el-form-item
          label="工艺技术现状："
          prop="techDesc"
          ref="techDesc"
          id="techDesc"
        >
          <el-input
            v-model="ruleForm.coopEnterpriseBO.techDesc"
            maxlength="100"
            class="input-long"
            placeholder="请输入工艺技术现状"
          />
        </el-form-item>
        <el-form-item
          label="所代理生产商名称："
          prop="agentProd"
          id="agentProd"
          ref="agentProd"
        >
          <el-input
            v-model="ruleForm.coopEnterpriseBO.agentProd"
            maxlength="100"
            class="input-long"
            placeholder="请输入所代理生产商名称"
          />
        </el-form-item>
        <el-form-item
          label="经销代理资格："
          prop="agentQual"
          id="agentQual"
          ref="agentQual"
        >
          <el-input
            v-model="ruleForm.coopEnterpriseBO.agentQual"
            maxlength="100"
            class="input-long"
            placeholder="请输入经销代理资格"
          />
        </el-form-item>

        <el-card-title :title="title2" />
        <el-button
          type="text"
          @click="dialogVisibleAdd = true"
          class="addServe"
        >
          <img
            style="position: relative; top: 1px"
            src="../../../../assets/images/addBox.png"
            alt
          />
          添加产品（服务）
        </el-button>
        <el-service-selector
          title="选择产品(服务)"
          :handleNodeClick="handleNodeClick"
          :props="props"
          @treeForm="treeForm"
          v-on:listenTochildEvent="showMessageFromChild"
          :loadNode="loadNodes"
          :isShowCol="isShowCol"
          :dialogVisible.sync="dialogVisibleAdd"
          :defaultExpandedKeys="arrFather"
          :defaultCheckedKeys="defaultCheckedKeys"
        ></el-service-selector>
        <div class="multiline-header" style="padding-left: 80px">
          <div class="multiline-header-from">
            <el-table :data="tableData">
              <el-table-column type="index" label="序号" width="50" />
              <el-table-column prop="id" label="产品（服务）编码" width="130">
                <template slot-scope="scope">{{ scope.row.id }}</template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="产品（服务）名称"
                width="130"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">{{ scope.row.name }}</template>
              </el-table-column>
              <el-table-column
                prop="productBrand"
                label="厂商或品牌"
                width="130"
              >
                <template slot-scope="scope">
                  <el-input
                    maxlength="100"
                    v-model="scope.row.productBrand"
                    class="input-short"
                    placeholder="请输入"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="note" label="备注">
                <template slot-scope="scope">
                  <el-input
                    maxlength="100"
                    v-model="scope.row.note"
                    class="input-short"
                    placeholder="请输入"
                  />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="50">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="text"
                    @click="handleDeleteTable(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <el-card-title :title="title3" />
        <el-form-item
          label="与同类行业企业合作业绩："
          prop="similarEnterprise"
          class="similarEnterprise"
        >
          <el-input
            v-model="ruleForm.coopEnterpriseBO.similarEnterprise"
            class="textarea-long"
            type="textarea"
            placeholder="请输入1000字以内的与同类行业企业合作业绩"
            maxlength="1000"
          />
        </el-form-item>
        <el-form-item label="合作企业：" prop="coEnterprise">
          <el-input
            v-model="ruleForm.coopEnterpriseBO.coEnterprise"
            class="textarea-long"
            type="textarea"
            placeholder="请输入1000字以内的合作企业"
            maxlength="1000"
          />
        </el-form-item>
        <el-form-item label="与中交合作业绩：" prop="coHistory">
          <el-input
            v-model.trim="ruleForm.coopEnterpriseBO.coHistory"
            class="textarea-long"
            type="textarea"
            placeholder="请输入1000字以内的与中交合作业绩"
            maxlength="1000"
          />
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            v-model="ruleForm.coopEnterpriseBO.remark"
            class="textarea-long"
            type="textarea"
            placeholder="请输入1000字以内的备注"
            maxlength="1000"
          />
        </el-form-item>
      </el-form>

      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="135px"
        class="demo-ruleForm"
      >
        <el-card-title :title="title4" />
        <div class="uploadInfo">
          <p class="commonTxtTip">
            支持格式：.jpg .png .jpeg .gif 每个不超过5M，.xls .xlsx .doc .docx
            .pdf每个不超过15M
          </p>
          <div v-show="isSafe">
            <div
              class="safe companyInfo"
              v-for="(item, key) in uploaderData"
              :key="key"
            >
              <uploader :aptitudeName="item.aptitudeName" ref="uploader" />
            </div>
          </div>
          <div
            class="safe companyInfo"
            v-for="(item, idx) in cloneObj"
            :key="item.id"
          >
            <children ref="children" :idx="idx" @hidden="hidden" />
          </div>

          <div class="addBox" @click="addTravel">
            <img
              style="position: relative; top: 1px"
              src="../../../../assets/images/addBox.png"
              alt
            />
            添加资质
          </div>
        </div>
      </el-form>
      <div class="footer">
        <el-button
          class="left-btn btn"
          size="mini"
          type="primary-icon-medium"
          @click="Previous('ruleForm')"
        >
          <span>上一步</span>
        </el-button>
        <el-button
          class="right-btn btn"
          size="mini"
          type="primary-icon-medium"
          @click="submitForm('ruleForm')"
          :disabled="submitDisabled"
        >
          <span>提交</span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  uploads,
  getIdByName,
  getSupplierType,
  getQryMatSubCatalog,
  getSubmitCoopUnit,
  getQryAptitudeBySupplierType,
  getQueryCoopUnit,
} from "@/api/register";
import children from ".././eqPerfectInfo/children";
import uploader from "./uploader";
export default {
  components: {
    children,
    uploader,
  },
  ready() {
    this.submitDisabled = false; //初始化为false表示是可以点击的
  },
  data() {
    return {
      fatherStr: "",
      treeFormData: [],
      defaultCheckedKeys: [],
      arrFather: [],
      arrSons: [],
      submitDisabled: false,
      firSecRule: false,
      thiFouRule: false,
      messageHeight: null,
      companyNameFlag: false,
      productFlag: false,
      radioValue: [],
      input: "",
      value: "",
      tableData: [],
      uploaderData: [],
      percentage: "100",
      codeList: [],
      moneyList: [],
      COMPCLASSList: [],
      IDList: [],
      // 批文附件上传
      picturePath: "../../.././examples/assets/images/file-icon/",
      importFileUrl:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/sra/reg/users/signup/uploadFileToOss", // 上传地址
      upLoadData: {
        cgformName: "t_b_tender_project",
        cgformField: "projectAttachment",
        cgformId: "",
      },
      fileList: [],
      fileListData: [],
      percentage1: "100",
      codeList1: [],
      moneyList1: [],
      COMPCLASSList1: [],
      IDList1: [],
      // 批文附件上传
      picturePath1: "../../.././examples/assets/images/file-icon/",
      upLoadData1: {
        cgformName: "t_b_tender_project",
        cgformField: "projectAttachment",
        cgformId: "",
      },
      fileList1: [],
      fileListData1: [],
      dialogImageUrl: "",
      dialogVisible: false,
      cloneObj: [],
      title: "意向合作",
      title1: "供应商类型",
      title2: "产品（服务）范围",
      title3: "合作业绩",
      title4: "上传资质",
      isSafe: true,
      imageUrl: "",
      subOption: "",
      supplierTypeCode: "02",
      //添加服务
      dialogVisibleAdd: false,
      isShowCol: false,
      defaultExpandedKeys: [],
      props: { id: "id", label: "name", children: "zones", isLeaf: "leaf" },
      //供应商类型
      supplierData: {
        supplierName: "装备供应商",
        data: [],
      },
      disabled: false,
      isLongValidity: false,
      value: 0,
      ruleForm: {
        appId: 1,
        groupId: 100002,
        capacity: "",
        techDesc: "",
        agentProd: "",
        agentQual: "",
        coopUnitBO: {
          unitId: null,
          supplierCode: "",
          companyId: "",
          companyName: "",
          recomName: "",
          recomMobile: "",
          supplierType: "",
          supplierTypeName: "",
          mainType: "1",
          orgId: "",
          companyNum: "",
        },
        coopEnterpriseBO: {
          epId: "",
          coEnterprise: "",
          coHistory: "",
          similarEnterprise: "",
          remark: null,
          capacity: "",
          techDesc: "",
          agentProd: "",
          agentQual: "",
        },
        productBOS: [],
        fileBOS: [],
      },
      rules: {
        companyName: [
          { required: true, message: "请输入合作单位", trigger: "blur" },
        ],
        capacity: [{ required: false, message: "请输入产能", trigger: "blur" }],
        techDesc: [
          { required: false, message: "请输入工艺技术现状", trigger: "blur" },
        ],
        agentProd: [
          {
            required: false,
            message: "请输入所代理生产商名称",
            trigger: "blur",
          },
        ],
        agentQual: [
          { required: false, message: "请输入经销代理资格", trigger: "blur" },
        ],
        similarEnterprise: [
          {
            required: true,
            message: "请输入与同类行业企业合作业绩",
            trigger: "blur",
          },
        ],
        scanFile: [
          {
            required: true,
            message: "请上传安全生产许可证扫描件",
            trigger: "blur",
          },
        ],
        scanFile2: [
          {
            required: true,
            message: "请上传合格业绩证明资质",
            trigger: "blur",
          },
        ],
        scanFile3: [
          {
            required: true,
            message: "请上传公司资质",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getBrowserHeight();

    //登录以后通过suppliercode获取合作信息
    this.$eventBus.$on("supplierCode", (res) => {
      console.log(res);
      if (res) {
        this.ruleForm.coopUnitBO.supplierCode = res;
        getQueryCoopUnit({
          isShowLoading: true,
          supplierCode: this.ruleForm.coopUnitBO.supplierCode,
          // supplierCode: "2020071308485253248"
        }).then((result) => {
          if (result.data.data.coopUnitBO.supplierCode != "") {
            console.log(result);
            this.ruleForm.coopUnitBO = result.data.data.coopUnitBO;
            if (this.ruleForm.coopUnitBO.companyName) {
              getIdByName({
                isShowLoading: true,
                companyName: this.ruleForm.coopUnitBO.companyName,
              }).then((res) => {
                this.rules.capacity = [];
                this.rules.techDesc = [];
                this.rules.agentProd = [];
                this.rules.agentQual = [];
                this.radioValue = [];
                console.log(res, "合作单位");
                if (res.data.data.id === 0) {
                  this.ruleForm.coopUnitBO.companyName = res.data.data.name;
                  this.companyNameFlag = true;
                  this.$message({
                    message: "合作单位不存在,请重新输入",
                    type: "warning",
                    offset: this.messageHeight,
                  });
                  this.ruleForm.coopUnitBO.companyId = "";
                } else {
                  this.companyNameFlag = false;
                  this.ruleForm.coopUnitBO.companyId = res.data.data.orgId;
                  this.ruleForm.coopUnitBO.orgId = res.data.data.orgId;
                  this.ruleForm.coopUnitBO.companyNum = res.data.data.autoCode;
                  if (this.ruleForm.coopUnitBO.companyId) {
                    //查询供应商类型
                    getSupplierType({
                      ownOrgId: this.ruleForm.coopUnitBO.companyId,
                      supplierTypeCode: this.supplierTypeCode,
                    }).then((res) => {
                      this.supplierData.data = res.data.data.supplierClassifyBo;
                      this.radioValue = result.data.data.coopUnitBO.supplierType
                        .split(",")
                        .map((item) => {
                          return item;
                        });
                      console.log(this.radioValue);

                      if (this.radioValue.indexOf("0201") !== -1) {
                        console.log("存在物资生产商");
                        this.firSecRule = true;
                      } else {
                        this.firSecRule = false;
                      }

                      if (this.radioValue.indexOf("0202") !== -1) {
                        console.log("存在物资经销商");
                        this.thiFouRule = true;
                      } else {
                        this.thiFouRule = false;
                      }

                      if (this.firSecRule === true) {
                        this.rules.capacity.push({
                          required: true,
                          message: "请输入产能",
                          trigger: "blur",
                        });
                        this.rules.techDesc.push({
                          required: true,
                          message: "请输入工艺技术现状",
                          trigger: "blur",
                        });
                      } else {
                        this.rules.capacity = [];
                        this.rules.techDesc = [];
                        this.$refs.capacity.clearValidate();
                        this.$refs.techDesc.clearValidate();
                      }

                      if (this.thiFouRule === true) {
                        this.rules.agentProd.push({
                          required: true,
                          message: "请输入所代理生产商名称",
                          trigger: "blur",
                        });
                        this.rules.agentQual.push({
                          required: true,
                          message: "请输入经销代理资格",
                          trigger: "blur",
                        });
                      } else {
                        this.rules.agentProd = [];
                        this.rules.agentQual = [];
                        this.$refs.agentProd.clearValidate();
                        this.$refs.agentQual.clearValidate();
                      }
                      this.arrFunction(this.supplierData.data);
                    });
                  }
                }
              });
            }

            this.ruleForm.productBOS = result.data.data.productBOS;
            this.tableData = [];
            if (this.ruleForm.productBOS) {
              for (let i = 0; i < this.ruleForm.productBOS.length; i++) {
                this.tableData.push({
                  id: this.ruleForm.productBOS[i].productCode,
                  name: this.ruleForm.productBOS[i].productName,
                  note: this.ruleForm.productBOS[i].productRemark,
                  mainClassCode: this.ruleForm.productBOS[i].topCode,
                  productBrand: this.ruleForm.productBOS[i].productBrand,
                  $treeNodeId: i,
                  leaf: false,
                });
                this.arrSons.push(this.ruleForm.productBOS[i].productCode);
                this.arrFather = this.ruleForm.productBOS[0].parentOrderCode.split(
                  ","
                );
              }
            }

            this.ruleForm.coopEnterpriseBO = result.data.data.coopEnterpriseBO;
            result.data.data.fileBOS.forEach((item) => {
              item.isLongValidity = item.isLongValidity === 0 ? false : true;
              if (item.fJName) {
                if (item.fJName.indexOf("xls") !== -1) {
                  item.fileAddress =
                    "data:image/png;base64,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";
                } else if (item.fJName.indexOf("doc") !== -1) {
                  item.fileAddress =
                    "data:image/png;base64,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";
                } else if (item.fJName.indexOf("pdf") !== -1) {
                  item.fileAddress =
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
                }
              }
            });
            this.cloneObj = [];
            if (result.data.data.fileBOS.length >= 1) {
              for (
                let index = 0;
                index < result.data.data.fileBOS.length;
                index++
              ) {
                let now = index;
                result.data.data.fileBOS[index]["id"] = index;
                console.log(result.data.data.fileBOS[index]);
                this.cloneObj.push(result.data.data.fileBOS[index]);
              }
            } else {
              this.cloneObj.push();
            }
            console.log(this.cloneObj, "克隆的接点");
            this.$nextTick(function () {
              for (let k = 0; k < result.data.data.fileBOS.length; k++) {
                if (this.cloneObj[k]) {
                  this.$refs.children[k].fileList = [
                    {
                      name: this.cloneObj[k].fileName,
                      url: this.cloneObj[k].fileAddress,
                      percentage: 100,
                      response: {
                        data: [
                          {
                            filePreview: this.cloneObj[k].fileClass,
                            downloadUrl: this.cloneObj[k].fileAddress,
                            fileType: this.cloneObj[k].fileType,
                            uploadId: this.cloneObj[k].uploadId,
                          },
                        ],
                      },
                    },
                  ];
                  this.$refs.children[k].uploadId = this.cloneObj[k].uploadId;
                  this.$refs.children[k].fileAddress = this.cloneObj[
                    k
                  ].fileAddress;
                  this.$refs.children[k].fileType = this.cloneObj[k].fileType;
                  this.$refs.children[k].ruleForm.website = this.cloneObj[
                    k
                  ].website;
                  this.$refs.children[k].ruleForm.fileName = this.cloneObj[
                    k
                  ].fileName;
                  this.$refs.children[k].ruleForm.validityStart = this.cloneObj[
                    k
                  ].validityStart;
                  this.$refs.children[k].ruleForm.validityEnd = this.cloneObj[
                    k
                  ].validityEnd;
                  this.$refs.children[
                    k
                  ].ruleForm.isLongValidity = this.cloneObj[k].isLongValidity;
                }
              }
            });
          }
        });
      }
    });
    //获取供应商类型初始化数据
    getSupplierType({
      // ownOrgId: this.ruleForm.coopUnitBO.companyId,
      ownOrgId: "",
      supplierTypeCode: this.supplierTypeCode,
    }).then((res) => {
      console.log(res, "供应商类型");
      this.supplierData.data = res.data.data.supplierClassifyBo;
      // this.ruleForm.coopUnitBO.supplierType = res.data.data.supplierTypeCode;
      this.arrFunction(this.supplierData.data);
    });
    // getQueryCoopUnit({ supplierCode: "2019110417253421136" }).then(res => {
    //   console.log(res, "查询合作信息");
    // });
  },
  methods: {
    treeForm(data) {
      this.treeFormData = data;
    },
    checkName() {
      this.ruleForm.coopUnitBO.recomName = this.ruleForm.coopUnitBO.recomName.replace(
        /[\&]/g,
        ""
      );
    },
    checkMobile() {
      this.ruleForm.coopUnitBO.recomMobile = this.ruleForm.coopUnitBO.recomMobile.replace(
        /[^\d\+\-\(\)\（\）]/g,
        ""
      );
    },
    //获取浏览器视口高度
    getBrowserHeight() {
      this.messageHeight = (window.innerHeight - 40) / 2;
      console.log(window.innerHeight, "高度");
    },
    //添加服务组件
    showMessageFromChild(data) {
      this.tableData = [];

      console.log(data, "所选数据");
      this.tableData.push(...data);
      this.tableData = [...new Set(this.tableData)];
      for (let i = 0; i < this.tableData.length; i++) {
        for (let j = i + 1; j < this.tableData.length; j++) {
          if (this.tableData[i].id === this.tableData[j].id) {
            this.tableData.splice(j, 1);
            j = j - 1;
          }
        }
      }
      console.log(this.tableData);
      // this.arrFather = [];
      this.arrSons = [];

      this.tableData.forEach((item) => {
        if (!this.arrFather.length) {
          this.arrFather.push(item.parentOrderCode);
        }

        this.arrSons.push(item.id);
      });
    },
    handleNodeClick(data) {
      console.log(data);
      // this.tableData.push(...data);
    },
    currentValue(dynamic1) {
      console.log(dynamic1);
    },
    loadNodes(node, resolve) {
      let nodes = [];
      this.defaultCheckedKeys = [];
      if (node.level === 0) {
        getQryMatSubCatalog({
          categoryClass: "5",
          categoryCode: "0",
        }).then((res) => {
          nodes = [];
          nodes = res.data.data.categoryList.map((item) => ({
            id: item.categoryCode,
            name: item.categoryName,
            leaf: item.isLeaf != 0,
            topCode: item.topCode,
            parentOrderCode: item.parentOrderCode,
          }));
          resolve(nodes);
        });
      } else {
        getQryMatSubCatalog({
          categoryClass: "5",
          categoryCode: node.data.id,
        }).then((res) => {
          nodes = [];
          nodes = res.data.data.categoryList.map((item) => ({
            id: item.categoryCode,
            name: item.categoryName,
            leaf: item.isLeaf != 0,
            topCode: item.topCode,
            parentOrderCode: item.parentOrderCode,
          }));
          this.arrFather.push(nodes[0].parentOrderCode);
          this.arrFather = [...new Set(this.arrFather)];
          resolve(nodes);
          this.$nextTick(() => {
            if (nodes.length == node.childNodes.length) {
              // this.defaultCheckedKeys = [...new Set(this.arrSons)];
              this.treeFormData.setCheckedKeys([...new Set(this.arrSons)]);
            }
          });
          this.arrSons = this.treeFormData.getCheckedKeys();
        });
      }
      if (node.level > 1) return resolve([]);
    },
    //删除表格数据
    handleDeleteTable(index, row) {
      this.tableData.splice(index, 1);
      console.log(index, row);
      this.arrSons.splice(this.arrSons.indexOf(row.id), 1);
      this.arrFather.splice(this.arrFather.indexOf(row.topCode), 1);
    },
    //转换时间格式
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    //查询合作单位是否存在
    getIdByName() {
      if (this.ruleForm.coopUnitBO.companyName) {
        getIdByName({
          isShowLoading: true,
          companyName: this.ruleForm.coopUnitBO.companyName,
        }).then((res) => {
          this.rules.capacity = [];
          this.rules.techDesc = [];
          this.rules.agentProd = [];
          this.rules.agentQual = [];
          this.radioValue = [];
          console.log(res, "合作单位");
          if (res.data.data.id === 0) {
            this.ruleForm.coopUnitBO.companyName = res.data.data.name;
            this.companyNameFlag = true;
            this.$message({
              message: "合作单位不存在,请重新输入",
              type: "warning",
              offset: this.messageHeight,
            });
            this.ruleForm.coopUnitBO.companyId = "";
          } else {
            this.companyNameFlag = false;
            this.ruleForm.coopUnitBO.companyId = res.data.data.orgId;
            this.ruleForm.coopUnitBO.orgId = res.data.data.orgId;
            this.ruleForm.coopUnitBO.companyNum = res.data.data.autoCode;
            // console.log(this.ruleForm.coopUnitBO.unitId);
            if (this.ruleForm.coopUnitBO.companyId) {
              //查询供应商类型
              getSupplierType({
                ownOrgId: this.ruleForm.coopUnitBO.companyId,
                // ownOrgId: "1681",
                supplierTypeCode: this.supplierTypeCode,
              }).then((res) => {
                console.log(res, "供应商类型");
                this.supplierData.data = res.data.data.supplierClassifyBo;
                // this.ruleForm.coopUnitBO.supplierType =
                //   res.data.data.supplierTypeCode;
                // let jsonData = JSON.parse(JSON.stringify(this.supplierData.data[0]))
                // jsonData.id = 80
                // console.log(this.supplierData.data,"供应商类型 ")
                // this.supplierData.data[0].supplierClassifyBO.push(jsonData)
                this.arrFunction(this.supplierData.data);
              });
            }
          }
        });
      }
    },
    arrFunction(res, id) {
      res.forEach((item) => {
        item.value = item.supplierTypeCode;
        item.hasRadio = true;
        item.pid = id;
        item.hasChildren = false;
        item.label = item.supplierTypeName;
        if (item.supplierClassifyBO) {
          if (item.supplierClassifyBO.length) {
            item.hasChildren = true;
            item.children = item.supplierClassifyBO;
            this.arrFunction(item.supplierClassifyBO, item.supplierTypeCode);
          }
        }
      });
    },
    //选择供应商类型
    selSupplier(value, label) {
      console.log(value);
      if (value) {
        if (value.indexOf("0201") !== -1) {
          console.log("存在物资生产商");
          this.firSecRule = true;
        } else {
          this.firSecRule = false;
        }

        if (value.indexOf("0202") !== -1) {
          console.log("存在物资经销商");
          this.thiFouRule = true;
          // this.rules.capacity = [];
          // this.rules.techDesc = [];
        } else {
          this.thiFouRule = false;
        }

        if (this.firSecRule === true) {
          this.rules.capacity.push({
            required: true,
            message: "请输入产能",
            trigger: "blur",
          });
          this.rules.techDesc.push({
            required: true,
            message: "请输入工艺技术现状",
            trigger: "blur",
          });
        } else {
          this.rules.capacity = [];
          this.rules.techDesc = [];
          this.$refs.capacity.clearValidate();
          this.$refs.techDesc.clearValidate();
        }

        if (this.thiFouRule === true) {
          this.rules.agentProd.push({
            required: true,
            message: "请输入所代理生产商名称",
            trigger: "blur",
          });
          this.rules.agentQual.push({
            required: true,
            message: "请输入经销代理资格",
            trigger: "blur",
          });
        } else {
          this.rules.agentProd = [];
          this.rules.agentQual = [];
          this.$refs.agentProd.clearValidate();
          this.$refs.agentQual.clearValidate();
        }
      } else {
        this.rules.capacity = [];
        this.rules.techDesc = [];
        this.rules.agentProd = [];
        this.rules.agentQual = [];
        this.$refs.capacity.clearValidate();
        this.$refs.techDesc.clearValidate();
        this.$refs.agentProd.clearValidate();
        this.$refs.agentQual.clearValidate();
        document.getElementById("capacity").classList.remove("is-error");
        document.getElementById("capacity").classList.add("fuckError");
        document.getElementById("techDesc").classList.remove("is-error");
        document.getElementById("techDesc").classList.add("fuckError");
        document.getElementById("agentProd").classList.remove("is-error");
        document.getElementById("agentProd").classList.add("fuckError");
        document.getElementById("agentQual").classList.remove("is-error");
        document.getElementById("agentQual").classList.add("fuckError");
      }
      this.ruleForm.coopUnitBO.supplierType = value;
      this.ruleForm.coopUnitBO.supplierTypeName = label;
      console.log(this.ruleForm.coopUnitBO.supplierType);
      if (this.ruleForm.coopUnitBO.companyId) {
        if (this.ruleForm.coopUnitBO.supplierType) {
          getQryAptitudeBySupplierType({
            ownOrgId: this.ruleForm.coopUnitBO.companyId,
            // ownOrgId: 23256,
            ids: this.ruleForm.coopUnitBO.supplierType
              .split(",")
              .map((item) => {
                return Number(item);
              }),
          }).then((res) => {
            this.uploaderData = res.data.data;
            this.$eventBus.$emit("uploaderData", this.uploaderData);
            console.log(res.data.data, "资质文件");
          });
        }
      }
    },
    addServe() {},
    //添加资质
    addTravel() {
      let now = Date.now();
      this.cloneObj.push({
        id: now,
      });
      console.log(this.cloneObj, "添加成功");
    },
    //删除资质
    hidden(idx) {
      console.log(idx);
      this.cloneObj.splice(idx, 1);
      console.log(this.cloneObj, "删除成功");
    },
    Previous() {
      this.$emit("Previous");
      this.$router.push({
        path: "/eqReady",
      });
      this.$eventBus.$emit("leaves", this.ruleForm.coopUnitBO.supplierCode);
      // this.$emit("querySupplierCode", this.ruleForm.coopUnitBO.supplierCode);
    },
    //提交合作
    submitForm() {
      let flag = true;
      let infoFlag = false;
      const isRuleForm = ["ruleForm.coopUnitBO", "ruleForm.coopEnterpriseBO"];
      console.log(this.$refs[isRuleForm]);
      isRuleForm.forEach((item) => {
        this.$refs[item].validate((valid) => {
          if (valid) {
            infoFlag = true;
          } else {
            flag = false;
            this.$nextTick(() => {
              const ele =
                this.$el.querySelector(".is-error") ||
                this.$el.querySelector(".is-required");
              console.log(ele);
              console.log(ele.offsetTop);
              if (ele) {
                // 获取到所在Row的offsetTop值
                window.scrollTo(
                  0,
                  ele.offsetTop ||
                    ele.parentNode.parentNode.parentNode.offsetTop
                );
              }
            });
            return false;
          }
        });
      });
      if (flag === false) {
        return false;
      }
      if (this.companyNameFlag === true) {
        this.$message({
          message: "合作单位不存在,请重新输入",
          type: "warning",
          offset: this.messageHeight,
        });
        this.ruleForm.coopUnitBO.companyName = "";
        return false;
      }
      if (this.ruleForm.coopUnitBO.companyId === "") {
        this.$message({
          message: "合作单位不存在,请重新输入",
          type: "warning",
          offset: this.messageHeight,
        });
        this.ruleForm.coopUnitBO.companyName = "";
        return false;
      }
      // console.log(this.ruleForm.coopUnitBO.supplierType, "供应商类型");
      if (this.ruleForm.coopUnitBO.supplierType === "") {
        this.$message({
          message: "请选择供应商类型",
          type: "warning",
          offset: this.messageHeight,
        });
        return false;
      }
      this.ruleForm.productBOS = [];
      if (this.arrFather.length) {
        this.fatherStr = this.arrFather.join(",");
      }

      this.tableData.forEach((item) => {
        this.ruleForm.productBOS.push({
          cateryClass: 1,
          productCode: item.id,
          productName: item.name,
          productRemark: item.note,
          mainClassCode: item.topCode,
          productBrand: item.productBrand,
          parentOrderCode: this.fatherStr,
        });
      });
      console.log(this.ruleForm.productBOS);
      if (this.ruleForm.productBOS.length > 0) {
        this.productFlag = true;
      } else {
        this.productFlag = false;
      }
      if (this.$refs.children) {
        this.ruleForm.fileBOS = [];
        this.$refs.children.forEach((item) => {
          // console.log(item, "====");
          // item.isLongValidity = item.isLongValidity === true ? 1 : 0;
          if (item.ruleForm.validityStart) {
            let startDate = new Date(item.ruleForm.validityStart);
            item.ruleForm.validityStart =
              startDate.getFullYear() +
              "-" +
              this.p(startDate.getMonth() + 1) +
              "-" +
              this.p(startDate.getDate());
          }
          if (item.ruleForm.validityEnd) {
            let endDate = new Date(item.ruleForm.validityEnd);
            item.ruleForm.validityEnd =
              endDate.getFullYear() +
              "-" +
              this.p(endDate.getMonth() + 1) +
              "-" +
              this.p(endDate.getDate());
          }

          if (item.fileList.length) {
            this.ruleForm.fileBOS.push({
              uploadId: item.uploadId,
              fileName: item.ruleForm.fileName,
              fileType: item.fileType,
              fileAddress: item.fileList[0].response.data[0].downloadUrl,
              fileSize: item.fileList[0].size,
              website: item.ruleForm.website,
              validityStart: item.ruleForm.validityStart,
              validityEnd: item.ruleForm.validityEnd,
              isLongValidity: item.ruleForm.isLongValidity,
            });
          }
        });
      }
      console.log(this.cloneObj);
      // console.log(this.ruleForm.fileBOS, "===");
      if (this.$refs.uploader) {
        this.$refs.uploader.forEach((item) => {
          // item.isLongValidity = item.isLongValidity === true ? 1 : 0;
          if (item.ruleForm.validityStart) {
            let startDate = new Date(item.ruleForm.validityStart);
            item.ruleForm.validityStart =
              startDate.getFullYear() +
              "-" +
              this.p(startDate.getMonth() + 1) +
              "-" +
              this.p(startDate.getDate());
          }
          if (item.ruleForm.validityEnd) {
            let endDate = new Date(item.ruleForm.validityStart);
            item.ruleForm.validityEnd =
              endDate.getFullYear() +
              "-" +
              this.p(endDate.getMonth() + 1) +
              "-" +
              this.p(endDate.getDate());
          }
          this.ruleForm.fileBOS.push({
            uploadId: item.uploadId,
            fileName: item.ruleForm.fileName,
            fileType: item.fileType,
            fileAddress: item.fileList[0].response.data[0].downloadUrl,
            fileSize: "",
            website: item.ruleForm.website,
            validityStart: item.ruleForm.validityStart,
            validityEnd: item.ruleForm.validityEnd,
            isLongValidity: item.ruleForm.isLongValidity,
          });
        });
      }
      let timeFlag = true;
      if (this.ruleForm.fileBOS) {
        this.ruleForm.fileBOS.forEach((item) => {
          item.isLongValidity = item.isLongValidity === true ? 1 : 0;
          if (item.validityStart) {
            if (item.isLongValidity !== 1) {
              if (!item.validityEnd) {
                timeFlag = false;
              }
            }
          }
        });
      }
      let timeFlag1 = true;
      if (this.ruleForm.fileBOS) {
        this.ruleForm.fileBOS.forEach((item) => {
          item.isLongValidity = item.isLongValidity == true ? 1 : 0;
          if (item.isLongValidity == 1) {
            if (item.validityStart == null) {
              timeFlag1 = false;
            }
          }
        });
      }
      //校验
      console.log(this.ruleForm.fileBOS);
      let listFlag = true;
      for (const i in this.ruleForm.fileBOS) {
        if (this.ruleForm.fileBOS[i]) {
          if (i === "uploadId") {
            if (!this.ruleForm.fileBOS.i) {
              listFlag = false;
            }
          }
        }
      }
      if (this.cloneObj.length && this.ruleForm.fileBOS.length === 0) {
        listFlag = false;
      }
      if (this.cloneObj.length > 0) {
        if (this.cloneObj.length === this.ruleForm.fileBOS.length) {
          listFlag = true;
        } else {
          listFlag = false;
        }
      }
      if (this.productFlag === false) {
        this.$message({
          message: "请添加产品（服务）范围",
          type: "warning",
          offset: this.messageHeight,
        });
        return false;
      }
      if (!timeFlag) {
        this.$message({
          message: "请选择资质文件有效期结束时间",
          type: "warning",
          offset: this.messageHeight,
        });
        return false;
      }
      if (!timeFlag1) {
        this.$message({
          message: "请选择资质文件有效期开始时间",
          type: "warning",
          offset: this.messageHeight,
        });
        return false;
      }
      if (!listFlag) {
        this.$message({
          message: "请将文件全部上传",
          type: "warning",
          offset: this.messageHeight,
        });
        return false;
      }
      this.ruleForm.fileBOS.forEach((item) => {
        if (item.website) {
          item.website = item.website.replace(/[\s\r\n]/g, "");
        }
      });
      if (this.ruleForm.coopEnterpriseBO.similarEnterprise != "") {
        this.ruleForm.coopEnterpriseBO.similarEnterprise = this.ruleForm.coopEnterpriseBO.similarEnterprise.replace(
          /(^\s*\n*)|(\s*\n*$)/g,
          ""
        );
      }
      //接收supplierCode
      this.$eventBus.$on("supplierCode", (res) => {
        console.log(res);
        this.ruleForm.coopUnitBO.supplierCode = res;
      });

      this.$eventBus.$emit("requireInfo", true);
      this.$nextTick(() => {
        const errorFormEl = document.body.querySelectorAll(".is-error");
        console.log(errorFormEl);
        if (!errorFormEl.length) {
          this.submitDisabled = true;
          setTimeout(() => {
            if (listFlag && this.productFlag) {
              this.ruleForm.coopUnitBO.mainType = "1";
              this.ruleForm.appUrl = this.$addUrlPerFix(
                process.env.VUE_APP_SUBMIT_URL
              );
              this.ruleForm.capacity = this.ruleForm.coopEnterpriseBO.capacity;
              this.ruleForm.techDesc = this.ruleForm.coopEnterpriseBO.techDesc;
              this.ruleForm.agentProd = this.ruleForm.coopEnterpriseBO.agentProd;
              this.ruleForm.agentQual = this.ruleForm.coopEnterpriseBO.agentQual;
              this.ruleForm.isShowLoading = true;
              this.ruleForm.loadingMessage = "保存中,请稍等...";
              setTimeout(() => {
                this.submitDisabled = false;
              }, 1000);
              getSubmitCoopUnit(this.ruleForm).then((res) => {
                // res.data.code = "100";
                if (res.data.code === "0") {
                  console.log(res, "提交");
                  this.$eventBus.$emit("last", {
                    companyName: this.ruleForm.coopUnitBO.companyName,
                    success: true,
                  });
                  this.$emit("next");
                } else {
                  this.submitDisabled = false;
                }
              });
            }
          }, 500);
        } else {
          document.documentElement.scrollTop =
            errorFormEl[0].offsetParent.offsetParent.offsetParent.offsetTop;
        }
      });
      // console.log(this.ruleForm);
    },

    // 附件信息上传
    changeFile(file, fileList) {
      // console.log("fileList:", fileList);
      this.fileList = fileList;
      for (let i = 0; i < fileList.length; i++) {
        if (
          ["doc", "docx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        }
      }
    },

    // 删除附件信息
    onFileDelete(file) {
      this.fileList.splice(file, 1);
    },

    // 点击已上传附件信息的时触发
    handlePictureCardPreview(file, fileList) {
      if (
        file.response.data[0].fileClass === 1 ||
        fileList[0].response.data[0].filePreview === 1
      ) {
        this.$message({
          message: "该文件类型不支持预览",
          type: "warning",
          offset: this.messageHeight,
        });
      } else {
        this.dialogVisible = true;
        this.dialogImageUrl = fileList[0].url;
      }
    },

    // 附件信息成功的时触发
    handleSuccess(response, file, fileList) {
      console.log(response.data[0], "上传打印1");
      console.log(file);
      this.ruleForm.fileBOS[0].uploadId = response.data[0].uploadId;
      this.ruleForm.fileBOS[0].fileType = response.data[0].fileType;
      this.ruleForm.fileBOS[0].fileName = response.data[0].fileName;
    },
    // 附件信息上传
    changeFile1(file, fileList) {
      // console.log("fileList:", fileList);
      this.fileList1 = fileList;
      for (let i = 0; i < fileList.length; i++) {
        if (
          ["doc", "docx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABPCAYAAACqNJiGAAAJHElEQVR4Xu2ce3RTRR7Hv0mapM2jadImLWyhIHaPFu2hlYe8KQVdWxChFMG6CFJYj+su9qyrnOOKehDOqvXB0ZUtbXkIFEFe9dFFdBErbFug5VFRVCrQLdD0lfSRtGnTZM8kJDc3CSv2NjdddubPe/ObO/O535nfzC/zu4Jrhs7jgGAMaLl5AnZ0CYT2dME1Q5f95q3oL10E7EAOhddHPVB4fQRHzCg8Co8DAQ6mVHkUHgcCHEyp8ig8DgQ4mFLlUXgcCHAwpcqj8DgQ4GBKlUfhcSDAwZQqj8LjQICDKS/Kq7zWjX/VWVjNHKkVY/qwUL9Nr2vrxf7vzT73fpesgEQk8Guz+1sz9KZe1r3FiXKopEIOeP67KS/wCLhHi1tYLUmKFmPv/Ci/rdt5zoznj7T63CvOjMLdOrHP9V6bHaMK9DD1MAFxdagQJx7XQSjwD7s/iPICr7vXjqQCPTqtTOckIuBMdgykIb6d+8uRVhSd81Xe2mkqLBop8+n3t009mLWriXV9dnwo1t+n7g9GN6yDF3jk6cs+acGXl9lDd/e8SIweJPFp3EMfNuFsQ4/PdQKOAPQu26vNWF3KVupr01WYf6cv6P6kyRu8rWdNePnrNlbbV41XYkWygnXNarPjro16ELV6FzJkydD1LjmfG1H8QyfrctkSHaLlov5k5VMXb/AuGq1I3dHIasDM4VLkpWlY18439SDNYwjKxQL3XEaGevXyGIi9nMaU9xtQ1844izsiQ1CyUBtQcKRy3uCRh03Z1gDiSV0lMoxM6tGsTu75zoxnDzND8JGRMtb89/GCKBBP7SrEw47f0sCqY0WSHKsmhN9a8Pw5gsNZWgyLCHF39OXSVmytdjqLGLkQa6apsPxTg/v+umkqLPRwGiUXOvHUZ0YWqG1zNJgYK7214B36qQtP/IMBQXr3eqoKGXcwE3vmvmaQdSEpM4ZLHQ5i3GZGWUSJr3g4jVeOtmHTGZMbVFiIAFXZ0ZDeYD3Yn0R5HbYd3TYkF+phtTFdWJQgw9oUpwe12e1IzNfDfH299vRYBf44RokJW/SoNzmNEnViHPBwGnP3NOGMnvHMKXFSFM5iz6P9CcyzLl7hkQc/vL8ZJ646lUXKrzUhOLjIObnXGKyYWcQ4lcJ0NVKGheKJkhYcuuhc5jicxooYiIUCdFkJ7HrWy3hxcjgeS5QHiherXt7h/e1kO96o6HA3giyRT2VHI1wqdCw3yLLDVSqW6qCVifDuyQ68WdHuvv7JgigkaMWouNKNRQeaWR36IkuL2zzm0EBS5B1edUM35nzI7vDmWRpMjZNi3bE2FJx2zl/RciHKljg9cWmtBUs+ZrZ3f01RYUGCDO9VdiC3nIEaqxShdLEukLyCqzybHRi7SY+WLmbi+8NoBXLGKZF1oBllV5xDOnWYFPnpzrnL0GnDPZv07oZn3SXDmqkqZH/agsOXmF3LjXYggaLJu/JIR54+ZMRHPzI7ggmxEmx7MBJJhfVoszh3Fi5n4er41G0N+Pf1NeIoElTIiHIANXq8hA0PqHH/bf4jNYEAGBR4+8534pl/MnObTCwAWfx67kAK0tWskNVTBw0oqelyMCDLkP2ZkUj7gAkGkPgCWaIoJIELQXm/gKDAazT3stZupFFP3iPHe5XMeq18iQ46j71pXlUHXi1j5rfHEmXYepaJvIwZJMauef5DXIFQHakzKPDIg9N3NeK7Jqu7X5pQoXse9HQWrh94xwQVYgE6POJ3fxqnwO9HKwPFyW+9QYP3alkb8qoYpXm2ztNZuK63d9swKl9P3rbfUpwZibt1vuGtQNIMGryyOguyvKLLro6uHKPAyrG+Kkrd0YCLRnaondgQ1R5/PBrCwAWNB5bySLyObNVcWzHP1uWnq5Hq5/8Nf3E7YvdgfBjevi8ikCIbWPBIa7zXaa4WejsL13USACCBAO+Sm6rCPI/gAl8UgzZsSQffrzbhpVI2DJ1MiPKl7BifCwbZE5O9sXe5EexAQwwqvEtGKxZ4wZgYK8FbM/3/cUOGeMr2BpbTGBERgp1zIwPNaeAN26D0uB8fGlTl9WM/glIVhccBO4VH4XEgwMGUKo/C40CAgylVHoXHgQAHU6o8Co8DAQ6mVHkUHgcCHEyp8ig8DgQ4mFLlUXgcCHAwdSgv/7jB3u37pxSHav8/TEOE9mcFg3Iv2Y30i0i/+I3HyEWrKbxfjM1pQOH1ERyFxwEchfe/Bk8rE+L1VCbBhGQqVjf0YPMZMyzXPT45tE3Oq6THS6GUCBynqd6oMOFUPXPqffQgMf58rwK3a0So77BhxzedKDrHTqHiyOZnzXmf8+JUIpzK1uLHFiu+b7ZCJxdi7GCJI/fi/p0tIMdut8+JQNrtofisxoLatl7MjpeCpIDO2t2Cyms9SIoRo+RhDYwWG0ouWBwn6icOkeDF0na8c8L/yaufJdGHHwQNXm55B9Ydc56Kf268As9NUODRYgNaOm0oWRiJjVUmrPrSeZjxV0qSZqVFWV03MvYaUPSQGjOGS3Dv5ib8dP3U1N4MNQYrRRi/hZ062gcmN20yIODFa0SoWKrF2qPtDuW9MFmJ6dubcdojOWXXPDUmD5Fg8Ho9ap7U4YLB6lBqMMuAgDc0XITTy7VYf9zkyALKGadAckEjLrUy2568NBUy7wyD7s161K2Mxte13cjcx07F4hvkgID3mxFSx1B85gtyYsqO3BkqPHLAgIM1TJpA6W8jESUTIiGvEVXLokCy35MLmtyHfhYmhCFeE4I1R5lzy4GGGTR4JFllQ6UZxIG8Nj0cseEiJBc2OoZt1TItalt7sfgjgyOPlqSAvjRFiXdPmrD6q3a8MInkbSiw7lg7/l5pRmI0OSmlxomrPZi/lz81Bg2epypILkXO520o/sGZKkC864YHIkBSDOx2OFR25DL5yIPRcZKUZDZ+MFeNyUOZM8jkuNrcPQZc9hjqt5zyyBrO8wsVJPmOLFu8ozpRYUJMjZM41nnnm60ov8L+5gA5fjxpiAQj1CJcbbfhq1qLe50YaGiu+nlXHl8d4+M5FB4HyhQeV3hD36q1Npp6A/sdDQ6NHKimwyPEzwtmF+kzvtFbEgZqIwdiu8LEwt5JceEb/wPl05FuSv4X0gAAAABJRU5ErkJggg==";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        }
      }
    },

    // 删除附件信息
    onFileDelete1(file) {
      // console.log(file);
      this.fileList1.splice(file, 1);
    },

    // 点击已上传附件信息的时触发
    handlePictureCardPreview1(file, fileList) {
      if (
        file.response.data[0].fileClass === 1 ||
        fileList[0].response.data[0].filePreview === 1
      ) {
        this.$message({
          message: "该文件类型不支持预览",
          type: "warning",
          offset: this.messageHeight,
        });
      } else {
        this.dialogVisible = true;
        this.dialogImageUrl = fileList[0].url;
      }
    },

    // 附件信息成功的时触发
    handleSuccess1(response, file, fileList) {
      console.log(response, "上传打印1111111");
      console.log(file);
      this.ruleForm.fileBOS[1].uploadId = response.data[0].uploadId;
      this.ruleForm.fileBOS[1].fileType = response.data[0].fileType;
      this.ruleForm.fileBOS[1].fileName = response.data[0].fileName;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}
.perfectingInformation {
  margin: 0 auto;
  .detailedInformation {
    width: 1180px;
    margin: 0 auto;
    margin-top: 20px;
    background: rgba(255, 255, 255, 1);
    position: relative;
    // padding-left: 154px;
    margin-bottom: 20px;
    .el-card-title {
      /deep/ .details-title {
        color: rgba(255, 20, 47, 1);
        border-bottom: 2px solid rgba(255, 20, 47, 1);
        top: 20px;
        margin-left: 20px;
      }
    }
    .el-form {
      .el-form-item {
        margin: 20px 0 0 45px;
        // color: rgba(208, 2, 27, 1);

        .format {
          font-size: 13px;
          font-family: PingFang-SC-Regular, PingFang-SC;
          font-weight: 400;
          color: rgba(155, 155, 155, 1);
          line-height: 17px;
        }
        /deep/ .el-form-item__label {
          padding: 1px 2px 0 0;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
        }
        /deep/ .el-form-item__content {
          .input-long {
            width: 430px;
          }
          .input-short {
            width: 430px;
          }
          .el-input__inner {
            padding: 0 10px;
            width: 430px;
          }
          .el-textarea {
            font-size: 13px;
            width: 430px;
            height: 70px;
            color: rgba(74, 74, 74, 1);
            font-family: PingFangSC-Regular, PingFangSC;
            font-weight: 400;
            line-height: 17px;
            &:-ms-input-placeholder {
              font-size: 13px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(155, 155, 155, 1);
            }
          }
        }
      }
    }
  }
  .footer {
    margin-left: 335px;
    display: flex;
    height: 80px;
    align-items: center;
    // justify-content: center;
    .left-btn {
      width: 240px;
      height: 40px;
      border-radius: 4px;
      margin-right: 20px;
      span {
        span {
          font-size: 16px;
          line-height: 15px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
        }
      }
    }
    .right-btn {
      width: 240px;
      height: 40px;
      border-radius: 4px;
      span {
        span {
          font-size: 16px;
          line-height: 15px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
        }
      }
    }
  }
}
.nameTip,
.codeTip1,
.codeTip2 {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 15px;
  top: 6px;
  padding-left: 20px;
}
.codeTip1 {
  top: 160px;
  left: 760px;
}
.codeTip2 {
  top: 175px;
  left: 760px;
}
.footer .btn {
  background-color: rgba(255, 20, 47, 1);
  border-color: rgba(255, 20, 47, 1);
}

.uploadInfo {
  padding-top: 17px;
  position: relative;
}
.safe {
  margin-bottom: 16px;
}
.safe .text {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
  margin-left: 48px;
}
.licenseWebsite {
  margin-left: 32px;
}
.demonstration {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
  margin-left: 119px;
}
.block {
  margin-top: 20px;
  margin-left: 6px;

  color: #4a4a4a !important;
}
.el-date-editor--date {
  width: 140px;
  height: 30px;
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
}

/deep/.checkBox {
  margin-left: 28px;
  /deep/.el-checkbox__label {
    position: relative;
    top: 1px;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  font-weight: 600;
  color: rgba(216, 216, 216, 1);
  background-color: rgba(223, 223, 223, 1);
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar-uploader {
  width: 80px;
  height: 80px;
  margin-left: 172px;
  margin-top: 29px;
  padding-bottom: 24px;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
.scanFile {
  position: absolute;
  left: 76px;
  top: 138px;
}
.scanFile2 {
  position: absolute;
  left: 66px;
  top: 334px;
}
.companyInfo {
  position: relative;
}
.scanFile3 {
  position: absolute;
  left: 102px;
  top: 172px;
}
.commonTxt {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 6px;
  margin-top: 10px;
  margin-left: 198px;
}
.commonTxt a {
  color: rgba(0, 137, 239, 1);
  cursor: pointer;
}
.isCommonTxt {
  margin-top: 16px;
}
.commonTxt span {
  color: rgba(0, 137, 239, 1);
  cursor: pointer;
}
.turnoverLastTxt {
  position: absolute;
  top: 1051px;
  left: 231px;
  font-size: 13px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}
.addBox {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(255, 20, 47, 1);
  line-height: 18px;
  margin-left: 50px;
  cursor: pointer;
  width: 20%;
}
.addServe {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(255, 20, 47, 1);
  line-height: 18px;
  cursor: pointer;
  padding-left: 587px;
}
.intelligence {
  margin-left: 94px;
}
.companyInfoTxt {
  position: absolute;
  top: 752px;
  left: 128px;
  font-size: 13px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}
.el-card-title {
  margin-top: 20px;
}
.el-button--small {
  color: rgba(85, 118, 207, 1);
}

.el-table {
  margin-left: 20px;
  margin-top: 21px;
  border: 1px solid rgba(241, 241, 241, 1);
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 17px;
  overflow-x: hidden;
  /deep/ td /deep/ .input-short {
    width: 100%;
  }
}

/deep/.el-table::before {
  height: 0;
}
.el-file-upload .file .file-list li {
  margin-right: 20px;
}
.multiline-header .multiline-header-from .el-table /deep/ th .cell {
  height: 16px !important;
  line-height: 16px !important;
  /deep/.input-short {
    width: 100%;
  }
}
.el-table {
  width: 600px;
  max-height: 397px;
  overflow: auto;
}
.supplierTypeNeed::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
  position: absolute;
  left: 134px;
  top: 7px;
  font-size: 14px;
}
/deep/.el-table thead {
  color: rgba(74, 74, 74, 1) !important;
}
/deep/.el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fuckError {
  /deep/.el-form-item__content {
    /deep/.el-form-item__error {
      display: none;
    }
  }
}
/deep/ .el-table__header-wrapper .has-gutter th:nth-child(2):before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
  position: absolute;
  left: 0;
  top: 14px;
  font-size: 14px;
}
/deep/ .el-table__header-wrapper .has-gutter th:nth-child(3):before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
  position: absolute;
  left: 0;
  top: 14px;
  font-size: 14px;
}
.commonTxtTip {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #ff142f;
  line-height: 6px;
  margin-top: 10px;
  margin-left: 20px;
  margin-bottom: 10px;
}
/deep/.el-textarea__inner {
  padding: 5px 10px !important;
  min-height: 64px !important;
}
</style>
<style>
.el-radio__input.is-checked .el-radio__inner {
  background-color: rgba(59, 136, 253, 1);
  border-color: rgba(59, 136, 253, 1);
}
.el-radio__input.is-checked + .el-radio__label {
  color: rgba(74, 74, 74, 1);
}
.el-radio__inner:hover {
  border: 1px solid rgba(59, 136, 253, 1);
}
.el-radio__label {
  width: 65px;
  height: 17px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFangSC;
  font-weight: 400;
  /* color: rgb(250, 189, 189); */
  line-height: 17px;
}
.similarEnterprise {
  position: relative;
  padding-left: 50px;
  margin-left: -5px !important;
}
.similarEnterprise label {
  position: absolute;
  left: -46px;
  width: 180px !important;
  margin-left: 50px;
}
</style>
